// ===================================================================
// src/app/components/auth/ProtectedRoute.tsx
//
// Guard de rota. Redireciona para /login se não autenticado.
// Mostra loading spinner enquanto verifica sessão.
// ===================================================================

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { loginPathFor } from '../../lib/loginRedirect';
import { useAuth } from '../../contexts/AuthContext';
import { Sparkles } from 'lucide-react';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[var(--background)]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-[#030213] flex items-center justify-center">
            <Sparkles className="w-6 h-6 text-white animate-pulse" />
          </div>
          <div className="w-6 h-6 border-2 border-[var(--muted-foreground)]/30 border-t-[var(--foreground)] rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={loginPathFor(location.pathname + location.search)} replace />;
  }

  return <Outlet />;
}
